import React from 'react';
import { baseUrl } from '../baseUrl';
import { useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useState, useEffect } from 'react';
import { styled} from '@mui/material/styles';
import axios from 'axios';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Quill from 'quill';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import { useNavigate } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import LogoutIcon from '@mui/icons-material/Logout';
import MoreIcon from '@mui/icons-material/MoreVert';
import CircularProgress from '@mui/material/CircularProgress';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import EditNotificationsOutlinedIcon from '@mui/icons-material/EditNotificationsOutlined';
import { Link } from 'react-router-dom';
// import MyplayerLogo from '../images/MyPlayerLogo.png';
import PrivacyTipRoundedIcon from '@mui/icons-material/PrivacyTipRounded';
import SupportRoundedIcon from '@mui/icons-material/SupportRounded';
import SupportAgentOutlinedIcon from '@mui/icons-material/SupportAgentOutlined';
// import Privacy from './Privacy';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';


const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  backgroundColor: theme.palette.primary.main,
}));


const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(0),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'center',
}));

const drawerWidth = 200;

const sidebar_icon = [LeaderboardOutlinedIcon, HomeOutlinedIcon, NotificationAddOutlinedIcon, PersonOutlineOutlinedIcon, CategoryOutlinedIcon, EditNotificationsOutlinedIcon]
const privacy_icon = [{'id':3,'icon':SupportRoundedIcon}, {'id':4,'icon':PrivacyTipRoundedIcon}, {'id':5, 'icon': SupportAgentOutlinedIcon},{'id':6,'icon':HandshakeOutlinedIcon}]

export default function PrivacyEditor() {
  const [editorHtml, setEditorHtml] = useState('');
  const [open, setOpen] = useState(false);
  const [drawerOpen, setDraweropen] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || '';
  const { username } = location.state || '';
  const { loginStatus } = location.state || false;
  useEffect(() => {
    if (loginStatus) {
      fetchTermsAndConditions()
    }
    else {
      navigate('/');
    }
  }, []);

  const fontSizeArr = ['8px', '9px', '10px', '12px', '14px', '16px', '20px', '24px', '32px', '42px', '54px', '68px', '84px', '98px'];

  var Size = Quill.import('attributors/style/size');
  Size.whitelist = fontSizeArr;
  Quill.register(Size, true);


  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);


  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLogout = async () => {
    try {
      if (loginStatus) {
        navigate('/cms');
        // setLogoutStatus('Logout successful');
      } else {
        // setLogoutStatus('Logout unsuccessful');
        alert("Logout unsuccessful")
        window.location.reload(true)
      }
    } catch (error) {
      alert("An error occurred during logout")
      console.error('Error:', error);
      //   setLogoutStatus('An error occurred during logout');
    }
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleLogout}>LogOut</MenuItem>
      {/* <MenuItem onClick={handleMenuClose}>My account</MenuItem> */}
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <LogoutIcon />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );


  const modules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'align': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image'],
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      // [{ 'font': [] }],
      [{ 'size': [] }],
      ['clean']
    ],
  };

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'align',
    'list', 'bullet', 'indent',
    'link', 'image',
    'color', 'background',
    // 'font',
    'size'
  ];



  // useEffect(() => {
  const fetchTermsAndConditions = async () => {
    try {
      const response = await axios.post(`${baseUrl}terms_conditions`, { "id": id });
      // console.log(response);
      setEditorHtml(response.data.result);
      setLoading(false)
    }
    catch (error) {
      alert('An error occurred during data fetching');
      console.error('Error:', error);
      setLoading(false);
    }
  };

  //   fetchTermsAndConditions();
  // }, [id]);

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`${baseUrl}submit`, { "id": id, "value": editorHtml });
      if (response.data.status.code === 200) {
        console.log('file saved');
        window.location.reload(true);
      }
    }
    catch (e) {
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          Error occurred — <strong>check it out!</strong>
        </Alert>
      </Stack>
    }

  };

  const handleDrawerToggle = () => {
    setDraweropen(!drawerOpen);
  };

 const handleClick = () =>{
    window.location.reload(true);
 }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={drawerOpen}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            sx={{ mr: 0, ...(open && { display: 'none' }) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            YaYa Player
          </Typography>

          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>

            <Typography variant="h6" noWrap component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {username}
            </Typography>

            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <LogoutIcon />
            </IconButton>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      <Drawer
        variant="persistent"
        anchor="left"
        open={drawerOpen}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <DrawerHeader>
          <img style={{ width: '50px', height: '50px', marginRight: '1px' }} src={"https://beeitech.com/images/logo/appicon.png"} alt='logo' />
        </DrawerHeader>
        <Divider />
        <List>

          <ListItem key="Dashboard" disablePadding>
            <ListItemButton component={Link} to="/cms/dashboard" state={{ username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(sidebar_icon[0])}
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton>
          </ListItem>

          <ListItem key="Home" disablePadding>
            <ListItemButton component={Link} to="/cms/homescreen" state={{ username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(sidebar_icon[1])}
              </ListItemIcon>
              <ListItemText primary="Home Screen" />
            </ListItemButton>
          </ListItem>

          <ListItem key="Send Notification" disablePadding>
            <ListItemButton component={Link} to="/cms/sendnotifications" state={{ username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(sidebar_icon[2])}
              </ListItemIcon>
              <ListItemText primary="Send Notification" />
            </ListItemButton>
          </ListItem>

          <ListItem key="Users" disablePadding>
            <ListItemButton component={Link} to="/cms/userpage" state={{ username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(sidebar_icon[3])}
              </ListItemIcon>
              <ListItemText primary="Users" />
            </ListItemButton>
          </ListItem>

          <ListItem key="Notifications Config" disablePadding>
            <ListItemButton component={Link} to="/cms/notificationsconfig" state={{ username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(sidebar_icon[5])}
              </ListItemIcon>
              <ListItemText primary="Notifications Config" />
            </ListItemButton>
          </ListItem>



        </List>
        {/* <Divider />
        <Privacy/> */}
        <Divider/>
        {/* <List>
          <ListItemButton component={Link} to="https://beeitech.com:3000/terms_condition">
            <ListItemText primary={<Typography variant="body2" style={{ color: '#000000', fontWeight: 'bold' }}>Terms & Conditions </Typography>} />
          </ListItemButton>
        </List> */}


        <List>

          <ListItem key="Terms & Conditions" disablePadding>
            <ListItemButton onClick={handleClick}  component={Link} to="/cms/editorwindow" state={{ id: privacy_icon[0].id, username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(privacy_icon[0].icon)}
              </ListItemIcon>
              <ListItemText primary="Terms & Conditions" />
            </ListItemButton>
          </ListItem>


          <ListItem key="Privacy & Policy" disablePadding>
            <ListItemButton onClick={handleClick} component={Link} to="/cms/editorwindow" state={{ id: privacy_icon[1].id, username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(privacy_icon[1].icon)}
              </ListItemIcon>
              <ListItemText primary="Privacy & Policy" />
            </ListItemButton>
          </ListItem>

          <ListItem key="Help & Support" disablePadding>
            <ListItemButton onClick={handleClick} component={Link} to="/cms/editorwindow" state={{ id: privacy_icon[2].id, username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(privacy_icon[2].icon)}
              </ListItemIcon>
              <ListItemText primary="Help & Support" />
            </ListItemButton>
          </ListItem>

          <ListItem key="Eula" disablePadding>
            <ListItemButton onClick={handleClick} component={Link} to="/cms/editorwindow" state={{ id: privacy_icon[3].id, username: username, loginStatus: loginStatus }}>
              <ListItemIcon>
                {React.createElement(privacy_icon[3].icon)}
              </ListItemIcon>
              <ListItemText primary="Eula" />
            </ListItemButton>
          </ListItem>


        </List>

      </Drawer >


      <div>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress style={{ 'color': '#ff3300e1' }} />
          </Box>
        ) : (
          <Main open={drawerOpen}>
            <DrawerHeader />
            {/* {editorHtml} */}
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              value={editorHtml}
              onChange={(html) => {
                setEditorHtml(html);
              }}
              readOnly={false} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginLeft: '200px' }}>
              <Button variant='text' sx={{textDecoration:'underline'}} onClick={() => window.open("https://beeitech.com/terms_condition")}> Terms & Conditions</Button>
              <Button variant='text' sx={{textDecoration:'underline'}} onClick={() => window.open("https://beeitech.com/privacy_policy")}> Privacy & Policy</Button>
              <Button variant="contained" size='medium' sx={{boxShadow:'0 8px 10px 10px rgba(138, 113, 113, 1)'}} onClick={handleSubmit} >SUBMIT</Button>
              <Button variant='text' sx={{textDecoration:'underline'}} onClick={() => window.open("https://beeitech.com/help_support")}> Help & Support</Button>
              <Button variant='text' sx={{textDecoration:'underline'}} onClick={() => window.open("https://beeitech.com/eula")}> Eula</Button>
            </div>
          </Main>
        )
        }
      </div>
    </Box>
  )
}
